/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MediaPolicyIn } from './mediaPolicyIn';
import type { OrgSettingsPutAudioPromptPolicy } from './orgSettingsPutAudioPromptPolicy';
import type { OrgSettingsPutChannels } from './orgSettingsPutChannels';
import type { OrgSettingsPutConsentCollection } from './orgSettingsPutConsentCollection';
import type { OrgSettingsPutConsentDefault } from './orgSettingsPutConsentDefault';
import type { OrgSettingsPutDisclosures } from './orgSettingsPutDisclosures';
import type { OrgSettingsPutInterviewerMetricsExposure } from './orgSettingsPutInterviewerMetricsExposure';
import type { OrgSettingsPutListingDefaults } from './orgSettingsPutListingDefaults';
import type { OrgSettingsPutModeRestrictions } from './orgSettingsPutModeRestrictions';
import type { OrgSettingsPutNotificationDefaults } from './orgSettingsPutNotificationDefaults';
import type { OrgSettingsPutOtherBotPolicy } from './orgSettingsPutOtherBotPolicy';
import type { OrgSettingsPutRecipientPolicy } from './orgSettingsPutRecipientPolicy';
import type { OrgSettingsPutScreenShareContent } from './orgSettingsPutScreenShareContent';
import type { OrgSettingsPutVideoLayout } from './orgSettingsPutVideoLayout';
import type { RetentionIn } from './retentionIn';

export interface OrgSettingsPut {
  consent_default?: OrgSettingsPutConsentDefault;
  consent_collection?: OrgSettingsPutConsentCollection;
  disclosures?: OrgSettingsPutDisclosures;
  grace_period_s?: number | null;
  consent_reminder_min?: number | null;
  notice_window_min?: number | null;
  notice_lead_min?: number | null;
  audio_prompt_policy?: OrgSettingsPutAudioPromptPolicy;
  allow_interviewer_consent_override?: boolean | null;
  own_domain_declines?: boolean | null;
  chat_known_unavailable?: boolean | null;
  retention?: RetentionIn | null;
  retention_preview_token?: string | null;
  media_policy?: MediaPolicyIn | null;
  export_transfer_allowed?: boolean | null;
  channels?: OrgSettingsPutChannels;
  participant_cap?: number | null;
  join_lead_min?: number | null;
  lobby_wait_min?: number | null;
  member_wait_min?: number | null;
  empty_room_wait_min?: number | null;
  overrun_allowance_min?: number | null;
  post_window_silence_min?: number | null;
  max_session_h?: number | null;
  panel_handoff_min?: number | null;
  min_duration_s?: number | null;
  notify_suppress_under_s?: number | null;
  paused_reminder_min?: number | null;
  default_adhoc_duration_min?: number | null;
  require_member_present?: boolean | null;
  keep_secondary_source?: boolean | null;
  video_layout?: OrgSettingsPutVideoLayout;
  mode_restrictions?: OrgSettingsPutModeRestrictions;
  screen_share_content?: OrgSettingsPutScreenShareContent;
  listing_defaults?: OrgSettingsPutListingDefaults;
  scheduler_default_access?: boolean | null;
  other_bot_policy?: OrgSettingsPutOtherBotPolicy;
  interviewer_metrics_exposure?: OrgSettingsPutInterviewerMetricsExposure;
  language?: string | null;
  code_switch_set?: string[] | null;
  recipient_policy?: OrgSettingsPutRecipientPolicy;
  notification_defaults?: OrgSettingsPutNotificationDefaults;
  attach_recap_pdf?: boolean | null;
  attach_transcript_pdf?: boolean | null;
  scorecard_auto_generate?: boolean | null;
  artifact_language?: string | null;
  regen_per_artifact_per_hour?: number | null;
  max_concurrent_bots?: number | null;
  daily_llm_token_budget?: number | null;
  daily_asr_minutes?: number | null;
  daily_upload_bytes?: number | null;
  max_calendars?: number | null;
  upload_presign_daily_user?: number | null;
  upload_presign_daily_org?: number | null;
  max_generators?: number | null;
  daily_notice_cap?: number | null;
  max_stream_connections?: number | null;
}
